module.exports = __webpack_public_path__ + "img/www.newegg.com.aa5aee8a.png";